<template>
  <div v-if="isDisplay" class="modal">
    <div class="modal-content">
      <div class="relative md:w-600 lg:w-800">
        <button class="close-btn z-50 focus:outline-none"
             @click="close">
          <i class="fal fa-times"></i>
        </button>
        <div class="grid md:grid-cols-2">
          <div>
            <img class="w-full h-306 object-cover lg:h-394" :src="background" :alt="altBackground">
          </div>
          <div class="w-full h-full pt-20 md:pt-80 px-20 relative pb-30">
            <div class="font-black mb-30 text-24 md:text-30">Follow {{ artist.name.trim() }}.</div>

            <div class="text-justify leading-tight mb-30">
              Be the first to be exclusively notified of new works by {{ artist.name.trim() }}.
            </div>

            <button @click="checkAuthentication" class="w-full py-16 text-white rounded-10 bg-orange focus:outline-none mb-30">
              FOLLOW NOW & SUBSCRIBE
            </button>

            <button class="w-full text-center underline text-18 focus:outline-none" @click="close">
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheArtistSubscriptionPanel",

  data () {
    return {
      api: '/web/api/subscribe/artist',
      isDisplay: false,
      artist: {},
      background: null,
      altBackground: null,
      formData: {
        artistSlug: '',
      }
    }
  },

  methods: {
    subscribe () {
      axios.post(this.api, this.formData)
        .then(({ data }) => {
          this.$artistSubscription.$emit('subscribe', this.formData.artistSlug)
          this.close()
          this.$root.$refs.notification.notify({
            title: data.title,
            message: data.message,
            type: 'warning-dark',
          })
        })
    },

    checkAuthentication () {
      axios.get('/web/api/subscribe/show')
        .then((success) => {
          this.subscribe()
        })
        .catch((error) => {
          if (error.response.status === 403) {
            let parameter = {follow_artist: this.formData.artistSlug}
            let header = `To follow ${this.artist.name}, sign in to drybrush Gallery`
            this.$root.$refs.signInModal.toggle(parameter, header)
            this.close()
          }
        })
    },

    open (artist, background, altBackground) {
      this.isDisplay = true
      this.artist = artist
      this.background = background
      this.altBackground = altBackground
      this.formData.artistSlug = artist.slug
      document.body.style.overflowY = 'hidden'
    },

    close () {
      this.isDisplay = false
      this.artist = {}
      this.background = null
      this.altBackground = null
      this.formData.artistSlug = ''
      this.formData.email = ''
      document.body.style.overflowY = ''
    },
  }
}
</script>

<style scoped>
.input-icon {
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 16px;
  margin-left: 16px;
  color: #a0aec0
}
</style>
